module.exports = __webpack_public_path__ + "img/HotAirBalloonLogo-400h.c7fc82cb.png";